// src/pages/costing/PageSFG.jsx
import { useState } from "react";
import { fmt4 } from "../../utils/costingUtils";
import { ModalWrap } from "../../components/ModalWrap";
import { FormulaSlots } from "../../components/FormulaSlots";

export function PageSFG({ sfgs, sfgFormulas, rms, sfgCost, fgs = [], fgFormulas = {}, onAdd, onSFGClick, onEdit }) {
  const [hovCol, setHovCol] = useState(null);
  return (
    <>
      <div className="page-header">
        <div className="page-header-left">
          <div className="page-title">Semi-Finished Goods</div>
          <div className="page-subtitle">Formulation &amp; cost breakdown</div>
        </div>
        <div className="page-header-right">
          <button className="btn-primary" onClick={onAdd}>+ Add SFG</button>
        </div>
      </div>
      <div className="card">
        <div className="table-wrap">
        <table className="data-table" data-hov-col={hovCol ?? undefined} onMouseLeave={() => setHovCol(null)}>
          <thead><tr>
            <th>SFG Code</th>
            <th>SFG Name</th>
            <th>Unit</th>
            <th>Formulation</th>
            <th>Used in FG</th>
            <th style={{ textAlign:"right" }}>Cost/kg (AED)</th>
            <th></th>
          </tr></thead>
          <tbody>
            {sfgs.map(sfg => {
              const formula   = sfgFormulas[sfg.id] || [];
              const cost      = sfgCost(sfg.id);
              const usedInFgs = fgs.filter(fg =>
                (fgFormulas[fg.id] || []).some(f =>
                  (f.componentId ?? f.id) === sfg.id && (f.type === "SFG" || f.type === "sfg")
                )
              );
              return (
                <tr key={sfg.id}>
                  <td onMouseEnter={() => setHovCol(0)}>
                    <div className="link fw-700" style={{ fontSize:12, color:"#6b21a8", display:"inline-block" }}
                      onClick={() => onSFGClick(sfg)}>{sfg.id}</div>
                  </td>
                  <td className="fw-600" onMouseEnter={() => setHovCol(1)}>{sfg.name}</td>
                  <td onMouseEnter={() => setHovCol(2)}>{sfg.unit}</td>
                  <td onMouseEnter={() => setHovCol(3)}>
                    <div style={{ display:"flex", flexWrap:"wrap", maxWidth:360 }}>
                      {formula.map(f => {
                        const rmId = f.rmId ?? f.id;
                        const rm   = rms.find(r => r.id === rmId);
                        return <span key={rmId} className="tag">{rm ? rm.name : rmId} {((f.proportion??f.qty??0)*100).toFixed(2)}%</span>;
                      })}
                      {!formula.length && <span style={{ color:"#ccc", fontSize:11 }}>No formula yet</span>}
                    </div>
                  </td>
                  <td onMouseEnter={() => setHovCol(4)}>
                    <div style={{ display:"flex", flexWrap:"wrap", gap:3 }}>
                      {usedInFgs.length > 0
                        ? usedInFgs.map(fg => (
                            <span key={fg.id} style={{ fontSize:10, background:"#eff6ff", color:"#1d4ed8", border:"1px solid #bfdbfe", borderRadius:3, padding:"1px 5px", fontFamily:"monospace" }}>{fg.id}</span>
                          ))
                        : <span style={{ color:"#d1d5db", fontSize:11 }}>—</span>
                      }
                    </div>
                  </td>
                  <td className="fw-700" style={{ textAlign:"right", color:"#166534" }} onMouseEnter={() => setHovCol(5)}>
                    {formula.length ? fmt4(cost) : "—"}
                  </td>
                  <td onMouseEnter={() => setHovCol(6)}>
                    <button className="btn-small" onClick={() => onEdit(sfg)}>Edit</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        </div>
      </div>
    </>
  );
}

export function AddSFGModal({ onSave, onCancel }) {
  const [f, setF] = useState({ name:"", unit:"kg" });
  return (
    <ModalWrap title="Add Semi-Finished Good" onClose={onCancel}>
      {[["SFG Name","name"], ["Unit","unit"]].map(([l,k]) => (
        <div key={k} className="form-row">
          <span className="form-label">{l}</span>
          <input className="form-input" style={{ flex:1 }} value={f[k]}
            onChange={e => setF(x => ({...x, [k]:e.target.value}))} />
        </div>
      ))}
      <div className="form-sep" />
      <div className="form-footer">
        <button className="btn" onClick={onCancel}>Cancel</button>
        <button className="btn-primary" onClick={() => { if (f.name) onSave(f); }}>Add</button>
      </div>
    </ModalWrap>
  );
}

export function EditSFGModal({ sfg, rms, formula, onSave, onCancel }) {
  const [slots, setSlots] = useState(formula.map(f => ({
    id:  f.rmId ?? f.id,
    qty: String(((f.proportion ?? f.qty ?? 0) * 100).toFixed(2)),
  })));
  return (
    <ModalWrap title={`${sfg.id} — ${sfg.name}`} onClose={onCancel}>
      <div style={{ fontSize:11, color:"#888", marginTop:-10, marginBottom:12 }}>Percentage (%) per kg of SFG. Total must = 100.00%</div>
      <FormulaSlots slots={slots} setSlots={setSlots} rms={rms} />
      <div className="form-footer">
        <button className="btn" onClick={onCancel}>Cancel</button>
        <button className="btn-primary" onClick={() =>
          onSave(sfg.id, slots.filter(s => s.id && parseFloat(s.qty) > 0).map(s => ({
            componentType: "RM", componentId: s.id, quantity: parseFloat(s.qty) / 100
          })))}>Save formula</button>
      </div>
    </ModalWrap>
  );
}

export function SFGFormModal({ sfg, sfgFormulas, rms, sfgCost, fgs, fgFormulas, onEdit, onClose }) {
  const formula  = sfgFormulas[sfg.id] || [];
  const total    = sfgCost(sfg.id);
  const fgsUsing = fgs.filter(fg => (fgFormulas[fg.id]||[]).some(f => (f.componentId??f.id) === sfg.id && (f.type==="SFG"||f.type==="sfg")));
  return (
    <div className="modal">
      <div className="modal-header" style={{ marginBottom:4 }}>
        <div className="modal-title" style={{ color:"#6b21a8" }}>{sfg.id}</div>
        <button className="btn-small" onClick={onClose}>✕</button>
      </div>
      <div style={{ fontSize:13, fontWeight:700, marginBottom:14 }}>{sfg.name}</div>
      {fgsUsing.length > 0 && (
        <div style={{ fontSize:11, color:"#888", marginBottom:12 }}>
          Used in: {fgsUsing.map(fg => <span key={fg.id} style={{ color:"#2563eb", marginRight:6 }}>{fg.id}</span>)}
        </div>
      )}
      <div className="table-wrap">
      <table className="data-table">
        <thead><tr>
          <th>Raw material</th>
          <th style={{ textAlign:"right" }}>Qty</th>
          <th style={{ textAlign:"right" }}>Unit price</th>
          <th style={{ textAlign:"right" }}>Contribution</th>
        </tr></thead>
        <tbody>
          {formula.map(f => {
            const rmId = f.rmId ?? f.id;
            const rm   = rms.find(r => r.id === rmId);
            const prop = f.proportion ?? f.qty ?? 0;
            return (
              <tr key={rmId}>
                <td className="fw-600">{rm ? rm.name : rmId}</td>
                <td style={{ textAlign:"right" }}>{(prop*100).toFixed(2)}%</td>
                <td style={{ textAlign:"right" }}>AED {fmt4(rm?.price||0)}</td>
                <td className="fw-700" style={{ textAlign:"right" }}>AED {fmt4((rm?.price||0)*prop)}</td>
              </tr>
            );
          })}
          <tr>
            <td colSpan={3} className="fw-700">Total cost / kg</td>
            <td className="fw-700" style={{ textAlign:"right", color:"#166534" }}>AED {fmt4(total)}</td>
          </tr>
        </tbody>
      </table>
      </div>
      <div className="form-footer" style={{ marginTop:16 }}>
        <button className="btn-small" onClick={() => onEdit(sfg)}>Edit formula</button>
        <button className="btn" onClick={onClose}>Close</button>
      </div>
    </div>
  );
}
